import { useMutation } from '@tanstack/react-query';
import { postUnifiedLoadLazyLoad } from '../../../api/v2/load';

export const useUnifiedLoadList = () => {
  const unifiedLazyLoadMutation = useMutation({
    mutationFn: (payload) => postUnifiedLoadLazyLoad(payload),
  });

  return { unifiedLazyLoadMutation };
};
